import { motion } from "framer-motion";

function About() {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section className="py-20 bg-white" id="about">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
          className="max-w-4xl mx-auto"
        >
          <motion.div variants={itemVariants} className="text-center mb-12">
            <span className="text-primary font-medium">About Me</span>
            <h2
              className="text-3xl md:text-4xl font-bold text-dark mt-2"
              id="about-title"
            >
              My Journey
            </h2>
            <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div variants={itemVariants} className="space-y-6">
              <h3 className="text-xl font-semibold text-dark">Who am I?</h3>
              <p className="text-gray-700">
                I'm a passionate and dedicated React Developer with a strong
                foundation in full-stack web development. I enjoy creating
                elegant, efficient, and user-friendly applications that solve
                real-world problems.
              </p>
              <p className="text-gray-700">
                With a growth mindset, I'm constantly learning and exploring new
                technologies to stay at the forefront of web development. I
                believe in writing clean, maintainable code and following
                industry best practices.
              </p>

              <div className="pt-4">
                <h3 className="text-xl font-semibold text-dark mb-4">
                  Personal Details
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-700">
                    <span className="text-primary mr-2">▹</span>
                    <span className="font-medium w-24">Name:</span> Abdullah
                    Alioğlu
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-primary mr-2">▹</span>
                    <span className="font-medium w-24">Experience:</span> 2+
                    Years
                  </li>
                  <li className="flex items-center text-gray-700">
                    <span className="text-primary mr-2">▹</span>
                    <span className="font-medium w-24">Location:</span>{" "}
                    Istanbul, Turkey
                  </li>
                  <li className="flex text-gray-700">
                    <span className="text-primary mr-2">▹</span>
                    <div>
                      <span className="font-medium w-24 inline-block">
                        Interests:
                      </span>
                      <div className="grid grid-cols-4 gap-2 mt-2 ">
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          React
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          Redux
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          Context API
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          React Query
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center ">
                          Next.js
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          Tailwind CSS
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          Component Design
                        </span>
                        <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-md text-center">
                          UX/UI
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </motion.div>

            <motion.div variants={itemVariants}>
              <div className="relative">
                <div className="absolute inset-0 bg-primary translate-x-4 translate-y-4 rounded-lg"></div>
                <img
                  src="https://opsgvvtoutcxldtxqkls.supabase.co/storage/v1/object/public/portfolio//domore_11zon.webp"
                  alt="About Abdullah"
                  className="relative z-10 rounded-lg shadow-lg w-full h-auto object-cover"
                  loading="lazy"
                />

                <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-lg shadow-lg z-20">
                  <div className="flex items-center space-x-2">
                    <div className="w-4 h-4 bg-red-500 rounded-full animate-pulse"></div>
                    <span className="text-gray-800 font-medium">Employed</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
